import {
  contextIsAvailable,
  extractTrackingPageContext,
} from '@aboutyou/legacy-shared/src/tracking/hooks/trackingHelpers'
import { trackAyCustomerDataOnce } from '@aboutyou/legacy-shared/src/tracking/utils/trackAyCustomerDataOnce'
import { CategoryDetailPageContext } from '@aboutyou/legacy-tracking-sdk'
import { useLegacyCustomerDataForAyTracking } from 'helpers/tracking/hooks/useLegacyCustomerDataForAyTracking'
import { useTracking } from 'helpers/tracking/hooks/useTrackingContextAndClientV6'
import { useTrackingPageUrl } from 'helpers/tracking/hooks/useTrackingPageUrl'
import { useEffect } from 'react'
import { useCategoryByPathname } from 'services/utils/context'

const useTrackPremiumPageView = () => {
  const { pageContext, TrackingClient } = useTracking()
  const customerDataPayload = useLegacyCustomerDataForAyTracking()
  const { path } = useTrackingPageUrl()

  // Extract category path from URL, /c/frauen/premium-144187 -> /frauen/premium
  // Needed since entities contain this path for the premium category
  const regex = /\/c(\/[^/]+\/[^/]+)-\d+/
  const match = path.match(regex)
  const categoryPath = match?.[1] || path

  const category = useCategoryByPathname(categoryPath)
  const categoryId = Number(category && category.id)

  useEffect(() => {
    if (
      contextIsAvailable(pageContext) &&
      !pageContext.disabled &&
      category &&
      categoryId === pageContext.id
    ) {
      const page = extractTrackingPageContext(pageContext)

      if (customerDataPayload) {
        trackAyCustomerDataOnce(TrackingClient, customerDataPayload)
      }
      TrackingClient?.trackCategoryView({
        page: page as CategoryDetailPageContext,
        categoryDetail: {
          id: categoryId,
          name: category.name,
          path: page.path,
        },
      })
    }
  }, [
    pageContext,
    category,
    categoryId,
    customerDataPayload?.type,
    TrackingClient,
  ])
}

export default useTrackPremiumPageView
